module.exports = __webpack_public_path__ + "media/images/create.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/create.png
// module id = 146
// module chunks = 0